export default "__VITE_ASSET__f4e55252__$_?react__"